import { Box, Image, Typography } from "@drone-js/core";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";

export const EmptyListing = () => {
    const {
        automaticPropertySelectionCms: { emptyTitle, emptySubtitle },
    } = usePropertySelectionViewModelValue();

    return (
        <Box display="flex" flexDirection="column" alignItems="center" my="48">
            <Image
                src="https://cdn6.agoda.net/images/homesOnboarding/home-check.svg"
                alt={emptyTitle}
                width="64px"
                height="64px"
            />
            <Typography variant="body-default-strong" textColor="base.default" textAlign="center" my="16">
                {emptyTitle}
            </Typography>
            <Typography variant="body-default" textColor="base.subtle" textAlign="center">
                {emptySubtitle}
            </Typography>
        </Box>
    );
};
